import ReferencialActionModal from 'components/modal/ReferencialActionModal'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import i18n from 'simple-react-i18n'
import { useDispatch } from 'react-redux'
import ToastrAction from 'toastr/actions/ToastrAction'
import { Box, Tooltip } from '@mui/material'
import { Tune } from '@mui/icons-material'
import { actionIconStyle } from 'components/ActionUtil'
import { keys } from 'lodash'

const UpdateReferencial = ({
    actions = {},
}) => {
    const [open, setOpen] = useState(false)

    const dispatch = useDispatch()

    const id = 'tune_action_navbar'

    return (
        <>
            <ReferencialActionModal
                open={open}
                setOpen={setOpen}
                actions={actions}
            />
            <Box px={2}>
                <Tooltip
                    id={id}
                    title={i18n.actions}
                    onClick={() => actions && keys(actions).length ? setOpen(true) : dispatch(ToastrAction.error(i18n.noData))}
                    data-cy={id}
                >
                    <Tune id={'tune'} sx={{ ...actionIconStyle }} />
                </Tooltip>
            </Box>
        </>
    )
}

UpdateReferencial.propTypes = {
    actions: PropTypes.shape({
        export: PropTypes.shape({
            data: PropTypes.arrayOf(PropTypes.object),
            titleFile: PropTypes.string,
            exportContent: PropTypes.element,
        }),
        sync: PropTypes.shape({
            updateAction: PropTypes.func,
            onImportXml: PropTypes.func,
            onImportCsv: PropTypes.func,
            xmlContent: PropTypes.element,
            csvContent: PropTypes.element,
            fileContentIsValid: PropTypes.bool,
        }),
        purge: PropTypes.shape({
            onPurge: PropTypes.func,
            onMakeInactive: PropTypes.func,
        }),
    }),
}

export default UpdateReferencial